import React from 'react';
import { LineOfBusinessTypes } from '../enums/ClaimTypes';
import colorPalette from '../themes/colorPalette';
import TextLabel from './TextLabel';
import useColor from '../hooks/useColor';

type LineOfBusinessProps = {
  lineOfBusiness: LineOfBusinessTypes;
  lineOfBusinessTranslation: any;
};

const { yellow, orange } = colorPalette;

const lineOfBusinessColors = {
  Home: {
    color: orange[9],
    backgroundColor: orange[1],
  },
  Motor: {
    color: yellow[9],
    backgroundColor: yellow[1],
  },
};

const LineOfBusiness = ({
  lineOfBusiness,
  lineOfBusinessTranslation,
  ...other
}: LineOfBusinessProps) => {
  const { color, backgroundColor } = useColor(
    lineOfBusinessColors,
    lineOfBusiness
  );

  return (
    <TextLabel
      color={color}
      bgcolor={backgroundColor}
      fontSize="15px"
      {...other}
    >
      {lineOfBusinessTranslation ?? lineOfBusiness}
    </TextLabel>
  );
};

export default LineOfBusiness;
